import React from "react";
import "react-markdown-editor-lite/lib/index.css";
import { Remarkable } from 'remarkable';
import loadable from "@loadable/component"

const Editor = loadable(() => import('react-markdown-editor-lite'))

export default class ProfileEditor extends React.Component {
  constructor(props) {
    super(props);
    this.editorRef = React.createRef();
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.renderHTML = this.renderHTML.bind(this);
    this.handleGetHtmlValue = this.handleGetHtmlValue.bind(this);
    this.getValue = this.getValue.bind(this);
    this.state = 
    {
        value: "",
        html: "",
    };
  }

  componentDidMount() {
    this.setState({
      value: this.props.value,
    });
  }

  handleEditorChange(text, html) {
    this.setState({
      value: text.text,
    });
    this.props.setStateFromChild(text.text);
  };

  getValue() {
    return this.state.value;
  }

  getHtmlValue() {
    return this.state.html;
  }

  handleGetHtmlValue() {
    if (this.editorRef.current) {
       return (this.editorRef.current.getHtmlValue());
    }
  }

  renderHTML(text) {
    var md = new Remarkable();
    this.setState({
      html: md.render(text),
    });
    return md.render(text);
  }

  render() {
    const plugins = ['header', 'font-bold', 'font-italic', 'list-unordered','block-quote', 'block-wrap', 'table', 'clear', 'logger', 'mode-toggle', 'full-screen', 'tab-insert'];
      return (
        <div className="cards-all">
          <Editor
            ref={this.editorRef}
            value={this.state.value}
            plugins={plugins}
            style={{
              height: "500px"
            }}
            config={{
              view: {
                  menu: true,
                  md: true,
                  html: true,
                  fullScreen: false,
              },
            }}
            onChange={this.handleEditorChange}
            renderHTML={this.renderHTML}
          />
        </div>
      )
  }
}